<div class="list">
  <h2>Layers</h2>
  <div
    class="layers"
    >
    @for (id of layerOrder; track id){
      @if (layers[id]; as layer) {
      <div
        #layerDiv
        class="layer"
        [class.selected]="selectedLayerId === layer.id"
        (click)="layerDivClicked(layer.id,layerDiv,$event)"
        >
        <div class="container">
          <div class="left-side">
            <p-checkbox
              id="checkbox"
              binary
              [(ngModel)]="checkboxSelected[layer.id]"
              />
              <div class="labels">
                <div class="title">{{layer.name}}</div>
                <div class="type">{{layer.layerType}} Layer</div>
              </div>
          </div>
          <div class="button-group" id="buttons">
            <p-button
              class="move"
              icon="pi pi-arrow-circle-up"
              [rounded]="true"
              [text]="true"
              [disabled]="$index === 0"
              severity="help"
              (click)="moveLayer.emit({direction: moveDirections.Up,layerId: layer.id})"
              />
            <p-button
              class="move"
              icon="pi pi-arrow-circle-down"
              [disabled]="$index === $count - 1"
              [rounded]="true"
              [text]="true"
              severity="help"
              (click)="moveLayer.emit({direction: moveDirections.Down,layerId: layer.id})"
              />
            <p-button
              [icon]="!layer.sharedSettings.visible ? 'pi pi-eye-slash' : 'pi pi-eye'"
              [rounded]="true"
              [text]="true"
              severity="info"
              (click)="toggleLayerVisibility.emit(layer.id)"
              />
            <p-button
              icon="pi pi-clone"
              [rounded]="true"
              [text]="true"
              severity="success"
              [disabled]="layer.layerType === layerTypes.Base"
              (click)="cloneLayer.emit(layer.id)"
              />
            <p-button
              icon="pi pi-trash"
              [rounded]="true"
              [text]="true"
              severity="danger"
              [disabled]="layer.layerType === layerTypes.Base"
              (click)="deleteLayer.emit(layer.id)"
              />
            <p-button
              [icon]="layer.sharedSettings.showEffects ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
              [rounded]="true"
              [text]="true"
              [disabled]="layer.effects.length === 0"
              severity="primary"
              (click)="toggleShowEffects.emit(layer.id)"
              />
          </div>
        </div>
        @if (layer.sharedSettings.showEffects){
          @for (effect of layer.effects; track effect){
          <div class="effect-list">
            <div class="labels">
              {{effect.effectType}}
            </div>
            <div class="actions">
              <p-button
                class="move"
                icon="pi pi-arrow-circle-up"
                [rounded]="true"
                [text]="true"
                [disabled]="$index === 0"
                severity="help"
                (click)="moveEffect.emit({direction: moveDirections.Up, effectId: effect.id, layerId: layer.id})"
                />
              <p-button
                class="move"
                icon="pi pi-arrow-circle-down"
                [disabled]="$index === $count - 1"
                [rounded]="true"
                [text]="true"
                severity="help"
                (click)="moveEffect.emit({direction: moveDirections.Down, effectId: effect.id, layerId: layer.id})"
                />
              <p-button
                icon="pi pi-cog"
                [rounded]="true"
                [text]="true"
                severity="info"
                (click)="selectEffect.emit(effect.id)"
                >
              </p-button>
              <p-button
                icon="pi pi-times-circle"
                [rounded]="true"
                [text]="true"
                severity="danger"
                (click)="deleteEffect.emit({layerId: layer.id, effectId: effect.id})"
                >
              </p-button>
            </div>
          </div>
          }
        }
      </div>
      }
    }
  </div>
</div>
